
















































































import v8n from 'v8n';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  Organisation,
  OrganisationUser,
  User,
  Legislation,
  OrganisationType,
} from '@/api';

import snackModule from '@/store/Snack';

import AvatarUpload from '@/components/common/AvatarUpload.vue';
import VitalAccessSelect from '@/components/common/VitalAccessSelect.vue';
import CountrySelect from '@/components/common/CountrySelect.vue';
import RelAutocompleteAsync from '@/components/common/RelAutocompleteAsync.vue';
import LegislationSelect from '@/components/common/LegislationSelect.vue';
import authModule from '@/store/Auth';
import SubscriptionPortalBanner from '../SubscriptionPortalBanner.vue';
import CancelSubscriptionBanner from '../CancelSubscriptionBanner.vue';

@Component({
  components: {
    AvatarUpload,
    CancelSubscriptionBanner,
    CountrySelect,
    LegislationSelect,
    VitalAccessSelect,
    RelAutocompleteAsync,
    SubscriptionPortalBanner,
  },
})
export default class OrganisationsEdit extends Vue {
  @Prop({ required: true }) readonly item: Organisation;

  organisation = new Organisation(); // tmp value

  owner: User | OrganisationUser | null = null;

  legislation: Legislation | null = null;

  ownerLoading = true;

  valid = false;

  loading = false;

  typeItems = [
    { text: 'Regular', value: 0 },
    { text: 'Training Provider', value: 1 },
    { text: 'Training Session', value: 2, disabled: true },
    { text: 'Trial', value: 3 },
  ];

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('common.validation.generalRequired'),
  ];

  requiredObject = [
    (v: User) => {
      if (!v) {
        return this.$t('common.validation.generalRequired');
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || this.$t('common.validation.generalRequired')
      );
    },
  ];

  get editMode() {
    return this.$route.name === 'organisations-edit';
  }

  get showCancelBanner() {
    return [
      OrganisationType.Regular,
      OrganisationType.TrainingProvider,
    ].includes(this.organisation.orgType);
  }

  get userScopeFactory() {
    return () => {
      return this.editMode
        ? OrganisationUser.includes(['user']).where({
            organisation: this.organisation.id,
          })
        : User.includes([]);
    };
  }

  async save() {
    if (!authModule.user) {
      authModule.logout();
      return;
    }
    try {
      this.loading = true;
      if (this.legislation && this.legislation.id) {
        this.organisation.defaultLegislation = this.legislation.coreId;
      }
      if (!this.organisation.id && authModule.user.id) {
        this.organisation.owner = authModule.user.id;
      }
      await this.organisation.save();
      this.$emit('updated', this.organisation);
      snackModule.setSuccess(this.$t('organisations.alerts.updated') as string);
    } catch (e) {
      snackModule.setError({
        text: this.$t('organisations.alerts.notUpdated') as string,
        errors: e.response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  @Watch('item', { immediate: true })
  async itemChanged() {
    this.organisation = this.item.dup();
  }
}
